import request from "@/utils/request";

export default function adminOpenCloseNewsLookNum(id,isShowLookNum) {
    return request({
        url: `/news/agencyOpenCloseNewsLookNum/`+id+`/`+isShowLookNum,
        method: 'get',
    })
}
